"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEvent = exports.getCategory = void 0;
const getCategory = (host, htmlElement) => {
    const allDotsRegex = /\./g;
    const treatedHost = host
        .replace('www.', '')
        .replace('.com', '')
        .replace('.br', '')
        .replace('.grupoboticario', '')
        .replace('.digital', '')
        .replace(allDotsRegex, ':');
    const autotaggingSectionElement = htmlElement === null || htmlElement === void 0 ? void 0 : htmlElement.closest('[data-autotagging-flora-section]');
    const autotaggingSection = autotaggingSectionElement
        ? autotaggingSectionElement.getAttribute('data-autotagging-flora-section')
        : '';
    return autotaggingSection ? `${treatedHost}:${autotaggingSection}` : `${treatedHost}:geral`;
};
exports.getCategory = getCategory;
const cleanEventString = (text) => {
    const allSpaceCharsRegex = /\s/g;
    const allLineBreakRegex = /\n/g;
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(allSpaceCharsRegex, '-')
        .replace(allLineBreakRegex, '-');
};
const sendEvent = (category, action, label) => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: 'event',
        eventCategory: cleanEventString(category),
        eventAction: cleanEventString(action),
        eventLabel: cleanEventString(label),
    });
};
exports.sendEvent = sendEvent;
